<template>
  <div class="about-section" :class="{'bg-violet': index === 1}">
    <div class="container">
      <div class="about-section__wrapper">
        <div 
          class="about-section__img" 
          :class="[
            { 'order-2': index === 1,
              'star-2' : index === 2
             },
            addDecorations
          ]"
        >
          <div v-if="addDecorations" class="decoration decoration--before"></div>
          <NuxtImg :src="about.photo.url" :alt="about.photo.alt" :class="['animate__animated', index === 1 ? 'animate__slideInRight' : 'animate__slideInLeft']" format="webp"
    loading="lazy" />
          <div v-if="addDecorations" class="decoration decoration--after"></div>
        </div>

        <div :class="{'order-1': index === 1}" class="about-section__content">
          <div v-if="index === 0" class="img-title">
            <div class="img-title__decoration"></div>
          </div>
          <h2>{{ about.titre }}</h2>
          <div v-html="about.contenu"></div>
          <a 
            v-if="index === 0" 
            class="btn-cv"
            href="/CV_Pauline.pdf" 
            target="_blank"
            rel="noopener noreferrer"
            title="Télécharger mon CV"
          >
            <img  src="/picto_CV.svg" alt="Télécharger mon CV"/>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang='ts'>
import type { Section } from '~/types/options';

const props = defineProps<{
  about: Section
  index:number
}>();


const addDecorations = computed(() => {
  if(props.index === 0 ||props.index === 2){
    return true
  }else{
    return false
  }
})
</script>

<style lang="scss">
.about-section {
  position: relative;
  padding-top: 20px;
  &__wrapper{
    display: flex;
    align-items: center;
    @media screen and (max-width:600px) {
      flex-direction: column;
    }
  }
  &.bg-violet {
    background-color: $violet_light;
    padding: 50px 0;
    margin: 100px auto;
    @media screen and (max-width:600px) {
      margin: 20px auto;
    }
    
    .about-section__img {
      position: absolute;
      right: 0;
      @media screen and (max-width:600px) {
      display: none;
    }
      
      img {
        height: 800px;
        width: 100%;
        object-fit: cover;
      }
    }
    
    .about-section__content {
      width: 50%;
      @media screen and (max-width:600px) {
      width: 100%;
    }
     h2{
      margin-bottom: 20px;
     } 
     p{
      font-weight: 600;
     }
    }
  }
  &:nth-child(4){
    
    @media screen and (max-width:600px) {
     .about-section__content{
        margin-top: 30px;
      }
    }
  }
  
   

  .btn-cv{
    display: block;
    margin-top: 40px;
    width: 70px;
    transition: all .2s;
    &:hover{
      transform: rotate(10deg) scale(.9);
    }
  }
  
  .img-title {
    width: 250px;
    height: 65px;
    position: relative;
    @media screen and (max-width:600px) {
       margin-top: 10px;
      }
    
    &__decoration {
      width: 100%;
      height: 100%;
      background-image: url('~/assets/svgs/hello.svg');
      background-repeat: no-repeat;
      background-position: center center;
      background-size: contain;
      position: absolute;
      top: -20px;
      left: -85px;
      @media screen and (max-width:600px) {
        top: 0;
        left: -25px;
      }
    }
  }
  
  &__img {
    width: 450px;
    position: relative;
    @media screen and (max-width:600px) {
        width:80%;
        max-height: 370px;
      }
    img{
      width: 100%;
      height: 100%;
    }
    
    // Decorations explicites
    .decoration {
      content: '';
      display: block;
      background-repeat: no-repeat;
      background-size: contain;
      position: absolute;
      
      &--before {
        top: -10px;
        right: 50px;
      }
      
      &--after {
        bottom: -10px;
        left: 0px;
      }
    }
    
    // Style star
      .decoration--before {
        background-image: url('~/assets/svgs/shape-3.svg');
        width: 45px;
        height: 90px;
        z-index: 2;
      }
      
      .decoration--after {
        background-image: url('~/assets/svgs/shape-2.svg');
        width: 100px;
        height: 135px;
      }
    
    // Style star-2
    &.star-2 {
      .decoration--before {
        background-image: url('~/assets/svgs/etoile1.svg');
        width: 50px;
        height: 50px;
      }
      
      .decoration--after {
        background-image: url('~/assets/svgs/duo-etoiles.svg');
        bottom: -30px;
        left: -30px;
        width: 120px;
        height: 125px;
      }
    }
  }
  
  &__content {
    width: 80%;
    @media screen and (max-width: 600px) {
        width: 100%;
      }
    
    &:not(.order-1) {
      padding-left: 120px;
      
      @media screen and (max-width: 1280px) {
        padding-left: 60px;
      }
      @media screen and (max-width: 600px) {
        padding-left: 20px;
      }
    }
    
    h2 {
      color: $violet;
      font-family: 'Open Sans', sans-serif;
      font-size: 20px;
      text-align: left;
      font-weight: 600;
      margin-bottom: 20px;
    }
    
    p {
      color: $text;
      font-weight: 600;
    }
  }
}
</style>